import { Observable } from 'rxjs'
import { User } from '../models/user'
import { OrgSettingsModel } from '../../org-management/models/org-settings-model'
import { AddressType } from '../../common/models/addresstype'

export abstract class UserGateway {
    abstract retrieveUser(userProfileID: number): Observable<User>
    abstract retrieveAdminPersonalDetails(): Observable<User>
    abstract isUserAuthorized(): Observable<boolean>
    abstract getFMOSettings(orgId: number): Observable<OrgSettingsModel[]>
    abstract getBackGroundCheckSetting(orgId: number): Observable<OrgSettingsModel[]>
    abstract getInsCompValidAddressTypes(orgId: number): Observable<AddressType[]>
}
